import React from 'react'
import {createRoot} from 'react-dom/client'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../core'
import * as WebDataRocksReact from 'react-webdatarocks'
import {GetDynamicReportEntityClient} from '../../../api'

//https://github.com/WebDataRocks/pivot-react/tree/master/typescript/src

function ChecksWithExpenseInvoice() {
  const intl = useIntl()

  const SERVICE_URL = window.ENVVARS.REACT_APP_SERVICE_URL
  const reportClient = new GetDynamicReportEntityClient(SERVICE_URL)

  reportClient.getChecksWithExpenseInvoiceQueryResponse().then((reportJson) => {
    let report = {
      formats: [
        {
          name: '',
          decimalPlaces: 4,
          thousandsSeparator: '.',
          decimalSeparator: ',',
        },
      ],
      dataSource: {
        data: reportJson,
      },
      localization: `https://cdn.webdatarocks.com/loc/${intl.locale}.json`,
      options: {
        grid: {
          type: 'flat',
          showGrandTotals: 'off',
        },
        showEmptyData: false,
      },
      slice: {
        columns: [
          {
            uniqueName: 'description',
            caption: 'ÇEK ADI',
          },
          {
            uniqueName: 'checkNo',
            caption: 'ÇEK NUMARASI',
          },
          {
            uniqueName: 'bankName',
            caption: 'ÇEK BANKASI',
          },
          {
            uniqueName: 'companyName',
            caption: 'VERİLEN FİRMA',
          },
          {
            uniqueName: 'editDate',
            caption: 'DÜZENLEME TARİHİ',
          },
          {
            uniqueName: 'defermentDate',
            caption: 'VADE TARİHİ',
          },
          {
            uniqueName: 'totalPrice',
            caption: 'ÇEK TUTARI',
          },
          {
            uniqueName: 'checkStateName',
            caption: 'ÇEK DURUMU',
          },
          {
            uniqueName: 'projectName',
            caption: 'PROJE',
          },
          {
            uniqueName: 'expenseInvoiceName',
            caption: 'ÇEKİN VERİLDİĞİ FATURA İSMİ',
          },
          {
            uniqueName: 'expenseInvoiceTotalPrice',
            caption: 'ÇEKİN VERİLDİĞİ FATURA TOPLAM TUTAR',
          },
          {
            uniqueName: 'expenseInvoiceBalance',
            caption: 'ÇEKİN VERİLDİĞİ FATURA KALAN BAKİYE TUTARI',
          },
        ],
      },
    }

    const root = createRoot(document.getElementById('report-app'))
    root.render(
      <WebDataRocksReact.Pivot
        toolbar={true}
        width='100%'
        height='100%'
        report={report}
        beforetoolbarcreated={customizeToolbar}
        customizeCell={customizeCellFunction}
      />
    )
  })

  function customizeToolbar(toolbar) {
    let tabs = toolbar.getTabs() // get all tabs from the toolbar
    toolbar.getTabs = function () {
      delete tabs[0] // delete Connect
      delete tabs[1] // delete Open
      return tabs
    }
  }

  function customizeCellFunction(cellBuilder, cellData) {
    if (cellData.hierarchy.uniqueName == 'checkNo' && cellData.hierarchy.type == 'value') {
      cellBuilder.text = new String(cellData.value)
    }
  }

  return (
    <>
      <PageTitle>
        {intl.formatMessage({id: 'DYNAMICREPORT.REPORT.CHECKSWITHEXPENCEINVOICE'})}
      </PageTitle>
      <div className='App' id='report-app' style={{height: '80vh'}} />
    </>
  )
}
export {ChecksWithExpenseInvoice}
